module.exports = __webpack_public_path__ + "img/pc6.b1c3c53b.png";